import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import qs from 'qs';

import Loader from '../../../components/Loaders/Loader';
import FilterGroup from '../../../components/Filters/FilterGroup';
import SearchGroup from '../../../components/Search/SearchGroup';
import Pagination from '../../../components/Pagination';
import Spinner from '../../../components/Loaders/Spinner';
import ConfirmModal from '../../../components/Modal/Confirm';
import ConfirmTemplates from './components/ConfirmTemplates';
import Table from './components/Table';

import { getMainList, getMainListPagination, changeStatus } from '../../../services/endpoints/affiliates';
import { prepareConfirmBtnsText } from '../helpers';

const Affiliates = ({ config }) => {
  const location = useLocation();

  const queryString = qs.parse(location.search.slice(1));

  const [init, setInit] = useState(false);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState({ pagination: true, modal: false, modalSubmit: false, table: true });
  const [openModal, setOpenModal] = useState('');
  const [modalData, setModalData] = useState({});

  const onHideModals = () => {
    setOpenModal('');
  };

  const fetchListPagination = async () => {
    setIsLoading((prevState) => ({ ...prevState, pagination: true }));

    try {
      const response = await getMainListPagination(queryString);
      if (response.success) {
        setData((prevState) => ({ ...prevState, pagination: response.data.pagination }));
      }
      setIsLoading((prevState) => ({ ...prevState, pagination: false }));
      return response.data;
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, pagination: false }));
      return error;
    }
  };

  const fetchList = async () => {
    setIsLoading((prevState) => ({ ...prevState, table: true }));
    try {
      const listResponse = await getMainList(queryString);
      if (listResponse.success) {
        !init && setInit(true);
        setData(listResponse.data);
        setIsLoading((prevState) => ({ ...prevState, table: false }));
        if (listResponse?.data?.need_pagination) {
          await fetchListPagination();
        } else {
          setIsLoading((prevState) => ({ ...prevState, pagination: false }));
        }
      }
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, table: false }));
    }
  };

  const onSubmitConfirm = async () => {
    setIsLoading((prevState) => ({ ...prevState, modalSubmit: true }));
    const status = modalData.actionKey === 1 ? 0 : 1;
    try {
      await changeStatus(modalData.item.id, status);
      onHideModals();
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
      fetchList();
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
    }
  };

  useEffect(() => {
    document.title = 'Affiliate referrals';
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <div>
      <ConfirmModal
        toggle={onHideModals}
        isOpen={openModal === 'confirm'}
        fetching={isLoading.modalSubmit}
        onConfirm={() => onSubmitConfirm()}
        title={<ConfirmTemplates.Title {...modalData} />}
        description={<ConfirmTemplates.Body {...modalData} />}
        {...prepareConfirmBtnsText(modalData?.actionKey)}
      />

      {isLoading.table && !init ? (
        <div className="loader-container" style={{ minHeight: '400px' }}>
          <Loader />
        </div>
      ) : (
        <>
          <FilterGroup>
            <SearchGroup autocomplete="on" sectionName="affiliates" placeholder="Search" />
          </FilterGroup>

          <Table
            sort={data.sort}
            isLoading={isLoading.table}
            items={data?.affiliates}
            config={config}
            setOpenModal={setOpenModal}
            setModalData={setModalData}
          />
          {isLoading.pagination ? (
            <div className="pagination">
              <Spinner />
            </div>
          ) : (
            <Pagination
              pages={data.pagination?.pages}
              currentPage={data.pagination?.current_page}
              itemsCount={data.pagination?.total_count}
              pageSize={data.pagination?.page_size}
              pagesLimit={data.pagination?.pages < 10 ? data.pagination?.pages : 10}
            />
          )}
        </>
      )}
    </div>
  );
};

Affiliates.propTypes = {
  config: PropTypes.object,
};

export default Affiliates;
